// lightweight nav only category data where the url is the top level category url.
// use this if you only need category data for the universal category nav and want to avoid
// the overhead of the full universal category data along with the recursive relationships
// between parent and child categories.
// generated at build time by scripts/build_data/copy_universal_categories.ts
import navCategories from '@/__data__/universal-categories-nav.json'
import { type UniversalNavCategory } from '@/features/shop/services/UniversalCategories/types'

export const getUniversalNavCategories = (): UniversalNavCategory[] => navCategories
